export default () => (next) => (action) => {
	return next(action);
};
